import { useLoggedInUser } from '~/pages/_shared/useLoggedInUser';
import {
   dismissGlobalUserNotification,
   getGlobalNotifications,
   GetGlobalNotificationsResult,
} from '~/monolith-api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { setCookie } from '@dozuki/web-js/utils';
import { LAST_CLOSED_WORLD_MESSAGE } from '~/framework';

const QUERY_KEY = 'global-notifications';

export function useGlobalNotifications() {
   const { data: user } = useLoggedInUser();
   return useQuery([QUERY_KEY], () => getGlobalNotifications(), {
      enabled: Boolean(user),
      refetchInterval: 300000, // 5 mins
   });
}

export function useDismissGlobalNotifications() {
   const { data } = useGlobalNotifications();
   const queryClient = useQueryClient();

   return useMutation(
      async () => {
         const secondsTimestamp = Math.floor(Date.now() / 1000).toString();
         setCookie(LAST_CLOSED_WORLD_MESSAGE, secondsTimestamp);

         if (!data) {
            return;
         }

         await Promise.all(
            data.notifications
               .filter(notification => notification.userid)
               .map(notification => dismissGlobalUserNotification(notification.notificationid))
         );
      },
      {
         onSuccess() {
            queryClient.invalidateQueries([QUERY_KEY]);
         },
         async onMutate() {
            await queryClient.cancelQueries([QUERY_KEY]);
            queryClient.setQueryData<GetGlobalNotificationsResult>([QUERY_KEY], {
               notifications: [],
            });
         },
      }
   );
}
